import type { Key } from 'react-aria-components';

export function getNewlyExpandedKeys(previous: Iterable<Key>, next: Iterable<Key>): string[] {
  const previousKeys = new Set(Array.from(previous, (key) => key.toString()));

  return Array.from(next, (key) => key.toString()).filter((key) => !previousKeys.has(key));
}
